import { render, staticRenderFns } from "./10_RegisterRequestFailed.vue?vue&type=template&id=bdcdee46&scoped=true&"
var script = {}
import style0 from "./10_RegisterRequestFailed.vue?vue&type=style&index=0&id=bdcdee46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcdee46",
  null
  
)

export default component.exports